// client/src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, authLoading } = useAuth();

  // Still checking cookie — show nothing (or a spinner)
  if (authLoading) return null;

  // No user — redirect to signin
  if (!user) return <Navigate to="/signin" replace />;

  // Logged in — render the page
  return children;
}
